import axios from 'axios'
import store from '../store/index'
import router from '../router'
import _ from 'underscore'

const API = axios.create({
  baseURL: `${process.env.VUE_APP_ROOT_API}/api/`,
  withCredentials: false,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

API.interceptors.request.use(
  function (config) {
    const token = sessionStorage.getItem('token')
    if (token) {
      if (process.env.VUE_APP_OAUTH_PROFILE_URL !== config.url) {
        config.headers.Authorization = `Bearer ${token}`
      }
    }
    return config
  },
  function (err) {
    return Promise.reject(err)
  }
)

API.interceptors.response.use(
  function (response) {
    if (response.data.error) {
      if (response.data.error === 'invalid_grant') {
        store.dispatch('logout')
      }
    }
    return response
  },
  function (err) {
    if (err.response && err.response.status === 401) {
      if (
        err.response.data.error === 'invalid_grant' ||
        err.response.config.url === process.env.VUE_APP_OAUTH_PROFILE_URL
      ) {
        store.dispatch('logout')
        router.push('/')
      } else {
        router.push('/')
      }
    }
    return Promise.reject(err.response)
  }
)

export const RootAPI = API

export function fetchItems (dataType, params) {
  return API.get(`V2/${dataType}`, {
    params
  })
}
export function fetchItem (dataType, id) {
  return API.get(`V2/${dataType}/${id}`)
}

export function fetchForm (formName) {
  return API.get(`forms/get/${formName}`)
}
export function itemsCount (dataType) {
  return API.get(`V2/${dataType}/count/`)
}

export function createItem (dataType, params) {
  return API.post(`V2/${dataType}`, params)
}
export function deleteItem (dataType, id, params) {
  return API.delete(`V2/${dataType}/${id}`, params)
}
export function updateItem (dataType, id, params) {
  return API.put(`V2/${dataType}/${id}`, params)
}

export async function upload (field, files) {
  let formData = new FormData()
  _.each(files, (element, index) => {
    formData.append(`${field}[]`, element)
  })
  return API.post('V2/upload/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export async function setPreferredLanguage (language) {
  return API.post(`V2/user/setLanguage`, { lang: language })
}
